<template>
  <ControlUnit
    class="control-panel__line"
    :title="$t('control.panel.demonstration')"
  >
    <button
      type="button"
      class="control-panel__btn btn btn--prim"
      @click="clickHandlerCallout"
    >Image callout</button>

    <!-- <button
      type="button"
      class="control-panel__btn btn btn--prim"
      @click="clickHandlerSlider"
    >Slider message</button> -->
  </ControlUnit>
</template>

<script>
import useStateController from './useStateController';

import ControlUnit from './ControlUnit.vue';

export default {
  components: {
    ControlUnit,
  },
  setup() {
    const { changeControlHandler } = useStateController();

    const clickHandlerCallout = () => {
      changeControlHandler({
        type: 'callout-image',
        value: null,
      });
    };

    const clickHandlerSlider = () => {
      changeControlHandler({
        type: 'slider-message',
        value: null,
      });
    };

    return {
      clickHandlerCallout,
      clickHandlerSlider,
    };
  },
};
</script>
